import AddImage from "../../ApiS/AddImage/AddImage";
import { Col, Row } from "../../ApiS/Grid-system/Grid-system";
import Input from "../Inputs/Input";
import Selected from "../Inputs/Selected";

interface TransferReqProps {}

const Transfer_Req: React.FC<TransferReqProps> = () => {
  return (
    <div className=" w-[90%] mx-auto">
      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> اسم الجامعة </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <div className=""> جامعة تشرين</div>
        </Col>
      </Row>
      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> اسم التخصص </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <div className="">برمجيات</div>
        </Col>
      </Row>
      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> الرقم الامتحاني </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <div className="">0000000000000</div>
        </Col>
      </Row>

      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> الاسم </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <div className=""> أحمد </div>
        </Col>
      </Row>

      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> النسبة </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <div className="">أحمد</div>
        </Col>
      </Row>

      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> الاب </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <div className="">أحمد</div>
        </Col>
      </Row>

      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> الام </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <div className=""> خلود</div>
        </Col>
      </Row>

      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5  flex items-center justify-center !mb-0"
        >
          <div className="font-bold text-base"> الرقم الوطني </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <Input
            placeholder=" الرقم الوطني "
            className="w-[450px] max-lg:!w-full"
          />
        </Col>
      </Row>

      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base mt-4">المقررات المعدلة</div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0 "
        >
          <Row justify={""}>
            <Col lg={10} md={4} className="mx-auto">
              {" "}
              <Selected
                title="رمز المقرر "
                //   name="payment_method_id"
                // text="أختر اسم المقرر"
                value={""}
                onChange={(e) => {
                  //   handleChangeInput(e);
                  // setSelectedOptionType(e.target.options[e.target.selectedIndex].dataset.type)
                }}
                className="!w-[430px] max-lg:!w-full mb-5 "
              >
                {/* {dataPayment?.data?.data?.map((e) => ( */}
                <option
                // key={e.id} value={e.id} data-type ={e.type}
                >
                  {/* {e.name} */}
                  React
                </option>
                {/* ))} */}
                <option>HTML</option>
                <option>CSS</option>
                <option>JS</option>
              </Selected>
            </Col>
            <Col lg={10} md={4} className="mx-auto">
              <table className=" w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
                <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
                  <tr>
                    <td> اسم المقرر </td>
                    <td> العلامة</td>
                  </tr>
                </thead>

                <tbody className="h-[70px]">
                  <tr className="border-2 border-white">
                    <td>برمجة</td>
                    <td>
                      <div className="flex justify-center">
                        <input
                          type="number"
                          placeholder="ادخل العلامة"
                          className="w-[200px] rounded-lg p-2"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> صورة كشف العلامات </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          {/* <AddImage
            id="image"
            type="IMAGE"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            title="صورة كشف العلامات"
            name="file"
            className="!bg-Main w-[90%] h-12 "
            onChange={(e) => {
              // setSuccessPost(0);
              // handleChangeInput(e);
            }}
          /> */}
        </Col>
      </Row>

      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> صورة حياة جامعية </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <AddImage
            id="image"
            type="IMAGE"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            title="صورة حياة جامعية"
            name="file"
            className="!bg-Main w-[90%] h-12 "
            onChange={(e) => {
              // setSuccessPost(0);
              // handleChangeInput(e);
            }}
          />
        </Col>
      </Row>

      <Row className=" border-2">
        <Col
          lg={6}
          md={6}
          sm={6}
          className=" border-l-2  p-5 text-center !mb-0"
        >
          <div className="font-bold text-base"> صورة موافقة النقل </div>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <AddImage
            id="image"
            type="IMAGE"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            title="صورة موافقة النقل"
            name="file"
            className="!bg-Main w-[90%] h-12 "
            onChange={(e) => {
              // setSuccessPost(0);
              // handleChangeInput(e);
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Transfer_Req;
